import React from 'react';
import Modal from '@aib/uikit-react/dist/Animations/Modal/Modal';
import InfoPopupView from '@aib/uikit-react/dist/Content/InfoPopupView/InfoPopupView';

interface Props {
  showModal: boolean;
  onClick: (...args: unknown[]) => unknown;
}

function CiamError({ showModal, onClick }: Props) {
  return (
    <Modal open={showModal}>
      <InfoPopupView
        title={'There is a mismatch with the information you gave us'}
        body={['Please try again or contact your Mortgage Advisor.']}
        isWarning
        buttonText={'Try again'}
        onClick={onClick}
        hasCloseButton={false}
      />
    </Modal>
  );
}

export default CiamError;
